import api from "../../../api";

export async function getFacilitatorCapabilityDecisions() {
  const response = await api.get("/facilitator-capabilities");
  const decisions = response.data?.decisions;
  if (!decisions?.activityAuthor || !decisions?.assignmentManage) {
    throw new TypeError("FACILITATOR_CAPABILITY_DECISIONS_INVALID");
  }
  return decisions;
}
